import { render, staticRenderFns } from "./LiabilitiesTable.vue?vue&type=template&id=d3c4414c&scoped=true&"
import script from "./LiabilitiesTable.vue?vue&type=script&lang=js&"
export * from "./LiabilitiesTable.vue?vue&type=script&lang=js&"
import style0 from "./LiabilitiesTable.vue?vue&type=style&index=0&id=d3c4414c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c4414c",
  null
  
)

export default component.exports